import React, { useEffect, useState } from "react";
import { Table, Typography, Button, Spin, Flex } from "antd";
import { render } from "@testing-library/react";
import { FaCircle } from "react-icons/fa";
import "./SubscriptionBillingHistory.css";
import { getBillingHistory } from "api/user.api";
import checkIcon from "../../images/checkIcon.svg";
import xCloseIcon from "../../images/xCloseIcon.svg";
import { text } from "stream/consumers";

const FaCircleSin = FaCircle as unknown as React.FC as any;

const { Text } = Typography;

const SubscriptionBillingHistory: React.FC = () => {
    const [billingHistoryData, setBillingHistoryData] = useState([]);
    const [loading, setLoading] = useState(false);

    const defaultPlans = ["Profile Views", "AI Screening", "Email Integration", "Candidate Export"];

    const transformedInvoices = (invoices: any) => {
        const transformedData = invoices.map((invoice: any, index: number) => {
            const planMap = new Map(invoice.plans.map((plan: any) => [plan.name, plan.credits]));
            // const planMap = new Map<string, number | null>(
            //     invoice.plans.map((plan: { name: string; credits: number | null }) => [plan.name, plan.credits])
            // );

            // const formattedPlans = defaultPlans.map(plan => {
            //     if (planMap.has(plan)) {
            //         return planMap.get(plan) !== null ? `${plan}: ${planMap.get(plan)}` : `${plan} ✔`;
            //     } else {
            //         return `${plan} ❌`;
            //     }
            // }).join(", ");
            const formattedPlans = (
                <Flex wrap="nowrap" gap="small">
                    {defaultPlans.map((plan, index) => (
                        <Flex key={plan} align="center">
                            {planMap.has(plan) ? (
                                planMap.get(plan) !== null ? (
                                    <span style={{ fontFamily: "Inter", color: "#475467" }}>{plan}: <span style={{ color: "#148C54", fontFamily: "Inter" }}>{planMap.get(plan) as string}</span></span>
                                ) : (
                                    <span style={{ fontFamily: "Inter", color: "#475467" }} className="flex gap-1">{plan} <img width="16" height="16" src={checkIcon} alt="✔" /></span>
                                )
                            ) : (
                                <span style={{ fontFamily: "Inter", color: "#475467" }} className="flex gap-1">{plan} <img width="16" height="16" src={xCloseIcon} alt="❌" /></span>
                            )}
                            {index !== defaultPlans.length - 1 && <span>,&nbsp;</span>}
                        </Flex>
                    ))}
                </Flex>
            );

            return {
                key: index,
                date: invoice.date,
                plan: formattedPlans,
                total: `$${invoice.amount_paid.toFixed(2)}`,
                status: invoice.status,
                invoice: "Download",
                invoice_link: invoice.invoice_pdf
            };
        });
        return transformedData;
    };

    const fetchbillingHistory = async () => {
        setLoading(true);
        try {
            const response = await getBillingHistory();
            console.log("Response: ", response);
            setBillingHistoryData(transformedInvoices(response));
        } catch (error) {
            console.log("Error: ", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchbillingHistory();
    }, []);

    useEffect(() => {
        console.log("Billing History data : ", billingHistoryData);
    }, [billingHistoryData]);

    const alignCenter = "center" as const;

    const columns = [
        {
            title: "Date",
            dataIndex: "date",
            key: "date",
            align: alignCenter,
            onCell: () => ({
                style: {
                    borderRight: "none",
                    fontFamily: "Inter",
                },
            }),
            onHeaderCell: () => ({
                style: { color: "#475467", fontFamily: "Inter" } // Change color here
            }),
        },
        {
            title: "Plan",
            dataIndex: "plan",
            key: "plan",
            onCell: () => ({
                style: {
                    borderRight: "none",
                    fontFamily: "Inter"
                },
            }),
            onHeaderCell: () => ({
                style: { color: "#475467", fontFamily: "Inter" } // Change color here
            }),
        },
        {
            title: "Total",
            dataIndex: "total",
            key: "total",
            align: alignCenter,
            onCell: () => ({
                style: {
                    borderRight: "none",
                    fontFamily: "Inter",
                },
            }),
            onHeaderCell: () => ({
                style: { color: "#475467", fontFamily: "Inter" } // Change color here
            }),
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            align: alignCenter,
            render: (status: string) => (
                <div className="flex justify-center items-center">
                    <div
                        style={{
                            display: "inline-flex",
                            alignItems: "center",
                            padding: "2px 8px",
                            border: "1px solid #ccc",
                            borderRadius: "6px",
                            backgroundColor: "unset",
                            cursor: "auto",
                            fontFamily: "Inter"
                        }}
                    >
                        <FaCircleSin
                            size={8}
                            style={{ color: status === "Paid" ? "#17B26A" : "red" }}
                            className="mx-1"
                        />
                        {status}
                    </div>
                </div>
            ),
            onCell: () => ({
                style: {
                    borderRight: "none"
                },
            }),
            onHeaderCell: () => ({
                style: { color: "#475467", fontFamily: "Inter" } // Change color here
            }),
        },
        {
            title: "Invoice",
            dataIndex: "invoice_link",
            key: "invoice_link",
            align: alignCenter,
            render: (text: string) => <a style={{ color: "#6941C6", textDecoration: "underline", fontFamily: "Inter" }} type="link" href={text}>Download</a>,
            onHeaderCell: () => ({
                style: { color: "#475467", fontFamily: "Inter" } // Change color here
            }),
        },
    ];

    const data = Array(10)
        .fill(null)
        .map((_, index) => ({
            key: index,
            date: "Jan 13, 2024",
            plan: "Profile Views: 125, AI Screening: 500, Email Integration ❌, Candidate Export ✔",
            total: "$125.00",
            status: "Paid",
            invoice: "Download",
        }));

    return (
        <div className="p-5">
            <div className="px-6 pt-4 pb-12 bg-white">
                {/* <Table columns={columns} dataSource={data} pagination={{ pageSize: 10 }} /> */}
                {
                    <Spin spinning={loading}>
                        <Table
                            className="custom-table"
                            columns={columns}
                            dataSource={billingHistoryData}
                            pagination={{ pageSize: 10 }}
                            bordered
                        />
                    </Spin>
                }
            </div>
        </div>
    );
};

export default SubscriptionBillingHistory;
